import { Component, OnInit, OnChanges } from '@angular/core';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { HomeService } from '../shared/home.service';
import { DialogStatusComponent } from '../quick-actions/dialog-status.component/dialog-status.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'status-units-graph',
  templateUrl: './status-units-graph.component.html',
  styleUrls: ['./status-units-graph.component.css']
})
export class StatusUnitsGraphComponent implements OnInit {
  public doughnutChartLabels: string[] = [];
  public doughnutChartOptions = {
    borderWidth: 1,
    maintainAspectRatio: false
  };
  public doughnutChartData: number[] = [];
  public doughnutChartType = 'doughnut';
  public doughnutChartLegend = true;

  constructor(private loggerService: LoggerService,
    private homeService: HomeService,
    public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.homeService.dataToBeTransmitted.subscribe(data => {
      this.doughnutChartLabels = [];
      this.doughnutChartData = [];
      data?.statusGraph.forEach(i => this.doughnutChartLabels.push(i?.status ? i.status : "Relay-Unit connection error"))
      data?.statusGraph.forEach(i => this.doughnutChartData.push(i.count))
    })
  }


  openAppropriateDialog(dialogName: string) {
    const dialogRef = this.dialog.open(DialogStatusComponent, {
      minWidth: '95vw',
      maxWidth: '95vw',
      minHeight: '50%',
      data: dialogName,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.homeService.getVMSStatistics().subscribe(data => {
        this.homeService.dataToBeTransmitted.next(data.data);
      }, err => {
        this.loggerService.log("ProvisionUnitsGraphComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
      })
    });
  }

  returnElementColor(element: string) {
    return "blue";
    // if (element == "No HTTPS response") return "red";
    // else if (element == "Idle" || element == "In a call") return "green";
    // else return "blue";
  }
}
